<script>
import { mapGetters, mapActions } from 'vuex';
import { find, uniq, cloneDeep } from 'lodash';
import ValidationsLieuxMixin from '../utils/validation-lieux.mixin';
import DatesLivraisonMixin from '../utils/dates-livraisons.mixin';
import LibelleDatesLivraison from '../../../../components/libelle-dates-livraison';

import FilArianne from './fil-arianne';

import LieuxDialog from './lieux-dialog';
import DatesDialog from './dates-dialog';
import { compareAsc, parseISO } from 'date-fns';

export default {
  name: 'Cart',
  components: {
    LieuxDialog,
    DatesDialog,
    LibelleDatesLivraison,
    FilArianne
  },
  mixins: [
    DatesLivraisonMixin,
    ValidationsLieuxMixin
  ],
  data: () => ({
    prevRoute: null,
    modal: false,
    modalKey: 0,
    currentLigne: null,
    modalRegt: false,
    loading: true,
    lieuxValidation: {
      lines: null,
      isError: null
    },
    datesValidation: {
      lignes: null
    },
    form: {
      commentairesEntete: {}
    },
    etatZoneCommentaire: false
  }),
  computed: {
    ...mapGetters({
      _lignesPanier: 'cart/cart',
      ref: 'referentiel/referentiel',
      paramsCommande: 'referentiel/paramsCommande',
      commentairesPanier: 'cart/commentairesPanier'
    }),

    lignesPanier () {
      return this._lignesPanier.slice().sort((a, b) => {
        let c = ('' + a.numAdresse).localeCompare('' + b.numAdresse);
        if (c !== 0) {
          return c;
        }
        c = compareAsc(parseISO(a.datePrevueLivraison), parseISO(b.datePrevueLivraison));
        if (c !== 0) {
          return c;
        }

        try {
          return a.idLigne.localeCompare(b.idLigne);
        } catch (e) { }
        return 0;
      });
    },
    cumulPetitCamion () {
      return this.lignesPanier
        .filter(ligne => ligne.codeModeCamion === 'VISP' || ligne.codeModeCamion === 'PNEUP')
        .reduce((total, ligne) => total + ligne.quantiteCommande, 0);
    },
    cumulSoufflerie () {
      return this.lignesPanier
        .filter(ligne => ligne.codeModeCamion === 'VIS' || ligne.codeModeCamion === 'PNEU')
        .reduce((total, ligne) => total + ligne.quantiteCommande, 0);
    },
    cumulQteCmde () {
      const cumulTotal = this.lignesPanier
        .reduce((total, ligne) => total + ligne.quantiteCommande, 0);
      return cumulTotal;
    },
    warningMessages () {
      const cumulPetitCamion = this.cumulPetitCamion;
      const cumulSoufflerie = this.cumulSoufflerie;

      return [
        cumulPetitCamion > 17 ? 'Attention, le poids total livré en petit camion représente ' + cumulPetitCamion + ' t, soit plus d’un petit camion (17 t)' : '',
        cumulSoufflerie > 27 ? 'Attention, le poids total livré en camion aliment représente ' + cumulSoufflerie + ' t, soit plus que la capacité d’un camion (27 t).' : ''
      ].filter(i => !!i);
    },
    zoneCommentaireVisible () {
      return this.etatZoneCommentaire || (this.form.commentairesEntete && Object.values(this.form.commentairesEntete).filter(i => !!i).length);
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  beforeDestroy () {
    this.addCommentaireCart(this.form.commentairesEntete);
  },
  async created () {
    await Promise.all([
      this.$lieuxValidationLoad(),
      this.$dateValidationLoad()
    ]);

    this.form.commentairesEntete = cloneDeep(this.commentairesPanier) || {};

    setTimeout(() => { this.loading = false; }, 50);
  },
  methods: {
    ...mapActions({
      removeLine: 'cart/removeLine',
      updateLine: 'cart/updateLine',
      clearCart: 'cart/resetCart',
      addCommentaireCart: 'cart/setCommentairesPanier'
    }),

    getLignesMelangePossible (ligne) {
      const props = [
        'datePrevueLivraison',
        'codeTypeSilo1',
        'codeTypeSilo2',
        'codeTypeSilo3'
      ];

      const lignes = [];
      for (const _ligne of this.lignesPanier) {
        let melangePossible = true;
        for (const key of props) {
          if (_ligne[key] !== ligne[key]) {
            melangePossible = false;
            break;
          }
        }
        if (melangePossible) {
          lignes.push(_ligne);
        }
      }

      return lignes;
    },
    toogleMelangeDechargement (ligne) {
      this.setMelangeDechargement(ligne, !ligne.melangeDechargement);
    },
    setMelangeDechargement (ligne, valeur) {
      this.getLignesMelangePossible(ligne).forEach(l => {
        const ll = cloneDeep(l);
        ll.melangeDechargement = !!valeur;
        this.updateLine({ oldLine: l, newLine: ll });
      });
    },
    supprimerLigne (ligne) {
      this.$dialog
        .confirm({ title: 'Suppression', text: 'Voulez-vous vraiment supprimer cette ligne de commande ?', actions: { true: { text: 'Oui', flat: false, outlined: true }, false: { text: 'Non', flat: false } } })
        .then(confirm => { if (confirm) this.removeLine(ligne); });
    },
    saveLigne (ligne) {
      this.setMelangeDechargement(this.currentLigne, false);
      ligne.melangeDechargement = false;

      this.updateLine({ oldLine: this.currentLigne, newLine: ligne });
      this.currentLigne = null;
      this.modal = false;
    },
    editLigne (ligne) {
      this.currentLigne = ligne;
      this.modal = true;
      this.modalKey++;
    },
    viderPanier () {
      this.$dialog
        .confirm({ title: 'Suppression', text: 'Voulez-vous vraiment supprimer toutes les lignes de votre panier ?', actions: { true: { text: 'Oui', flat: false, outlined: true }, false: { text: 'Non', flat: false } } })
        .then(confirm => { if (confirm) this.clearCart(); });
    },
    validerPanier (force) {
      this.addCommentaireCart(this.form.commentairesEntete);

      if (this.validationDates()) {
        this.datesValidation.lignes = this.validationDates();
        return;
      }

      if (force === true || this.validationLieux()) {
        this.$router.push({
          name: 'main.catalog.cart.validPanier'

        });
      }
    },
    getLibelleModeCamion (code) {
      const mode = find(this.ref.modesCamion, { code });
      if (mode) {
        return mode.libelle + (mode.libelleOption ? ' (' + mode.libelleOption + ')' : '');
      } else {
        return '';
      }
    },
    validationLieux () {
      const lignesAlerte = [];
      const lignesErreur = [];
      const lignesVide = [];

      for (const ligne of this.lignesPanier) {
        const err = this.$lieuxValidation.validationLivraison(ligne);
        if (err.alert) {
          lignesAlerte.push(ligne);
        }

        if (err.error) {
          lignesErreur.push(ligne);
        }

        if (err.vide) {
          lignesVide.push(ligne);
        }
      }

      if (lignesErreur.length) {
        // todo affichage popup erreur
        this.lieuxValidation.lines = lignesErreur;
        this.lieuxValidation.isError = true;

        return false;
      } else if (lignesAlerte.length) {
        // todo affichage popup confirmation
        this.lieuxValidation.lines = lignesAlerte;
        this.lieuxValidation.isError = false;

        return false;
      } else if (lignesVide.length) {
        // todo affichage popup confirmation
        this.lieuxValidation.lines = lignesVide;
        this.lieuxValidation.isVide = true;

        return false;
      } else {
        return true;
      }
    },
    closeAlertPopup (result) {
      this.lieuxValidation.lines = null;
      this.lieuxValidation.isError = null;

      if (result) {
        this.validerPanier(true);
      }
    },
    closeDatesPopup () {
      this.datesValidation.lignes = null;
    },
    nbJoursEcartMinDatesLivraison (ligne) {
      let nbJoursEcartMin = 0;
      if ((ligne.codeFamilleArticle === '461') || ligne.modeCamion === 'VISP' || ligne.modeCamion === 'PNEUP') {
        nbJoursEcartMin = 1;
      }

      return nbJoursEcartMin;
    },
    validationDatesLigne (ligne) {
      return this.$dateValidation.validationDate('DATE_DEBUT', ligne.datePrevueLivraison, ligne.dateFinPrevueLivraison, this.nbJoursEcartMinDatesLivraison(ligne));
    },
    validationDates () {
      const lignesErreur = [];
      for (const ligne of this.lignesPanier) {
        if (this.validationDatesLigne(ligne) !== null) {
          lignesErreur.push(ligne);
          ligne.datesInvalides = true;
        }
      }

      return lignesErreur.length ? lignesErreur : false;
    },
    hasSameDateFin (lignes) {
      return uniq(lignes.map(l => l.finDatePrevueLivraison)).length === 1;
    },
    afficherZoneCommentaire () {
      this.etatZoneCommentaire = true;
    },
    continuerAchats () {
      if (this.prevRoute && this.prevRoute.name && !~this.prevRoute.name.indexOf('cart') && ~this.prevRoute.name.indexOf('catalog')) {
        this.$router.back();
        return;
      }
      this.$router.push({ name: 'main.catalog' });
    }
  }
};
</script>

<template>
  <Loader v-if="loading" />
  <div v-else>
    <FilArianne :step="1" />
    <h2 class="primary--text">
      Panier
      <CardsHelp
        :page="'VALID-PANIER'"
        :niveau="'TITRE'"
      />
    </h2>

    <CardsList
      :items="lignesPanier"
      column-size="100%"
      :group-by="ligne=>({numAdresse:ligne.numAdresse, dateDebut:ligne.datePrevueLivraison})"
    >
      <template v-slot:empty>
        Votre panier est vide
      </template>
      <template v-slot:groupTitle="{group, items}">
        <div class="secondary--text">
          <RefValue
            :code="group.numAdresse"
            type="ADRESSE"
          /><br>
          <span v-if="hasSameDateFin(items)">
            Livraison du {{ group.dateDebut | date }} au {{ items[0].finDatePrevueLivraison | date }}
          </span>
          <span v-else>
            Livraison à partir du {{ group.dateDebut | date }}
          </span>
        </div>
      </template>
      <template v-slot:item="{item}">
        <CardsListItemLigneCommande
          :ligne="item"
          :class="{'lieux_warning':$lieuxValidation.validationLivraison(item).alert,
                   'lieux_error':$lieuxValidation.validationLivraison(item).error}"
        >
          <template v-slot:actions="{ligne}">
            <div v-if="isMobile">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-icon
                    class="action-btn"
                    v-on="on"
                  >
                    mdi-dots-vertical
                  </v-icon>
                </template>
                <v-list>
                  <v-list-item-group>
                    <v-list-item
                      inactive
                      @click="editLigne(ligne)"
                    >
                      <v-list-item-title>
                        Modifier
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item
                      inactive
                      @click="supprimerLigne(ligne)"
                    >
                      <v-list-item-title>
                        Supprimer
                      </v-list-item-title>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </div>
            <div
              v-else
              class="desktop-ligne-actions"
            >
              <v-btn
                outlined
                color="secondary"
                @click="editLigne(ligne)"
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
              <v-btn
                outlined
                color="secondary"
                @click="supprimerLigne(ligne)"
              >
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </div>
          </template>

          <template v-slot:infos="{ligne}">
            <div v-if="ligne.codeModeCamion">
              Camion : {{ getLibelleModeCamion(ligne.codeModeCamion) }}
              <v-icon v-if="ligne.commentaire || ligne.commentairesPredefinis">
                mdi-message-outline
              </v-icon>
            </div>
            <LibelleDatesLivraison
              :date-debut="ligne.datePrevueLivraison"
              :date-fin="ligne.finDatePrevueLivraison"
              :horaire-debut="ligne.matinApmidi"
              :horaire-fin="ligne.finMatinApmidi"
            />
            <div
              v-if="$lieuxValidation.validationLivraison(ligne).vide"
              class="error white--text py-1 px-3"
            >
              <v-icon color="white">
                mdi-alert-circle-outline
              </v-icon>
              Au moins un lieu de stockage doit être renseigné.
            </div>

            <div
              v-if="$lieuxValidation.validationLivraison(ligne).error"
              class="error white--text py-1 px-3"
            >
              <v-icon color="white">
                mdi-alert-circle-outline
              </v-icon>
              Un autre aliment pour une autre espèce doit être livré aux mêmes dates dans les mêmes lieux de stockage.
            </div>
            <div
              v-else-if="$lieuxValidation.validationLivraison(ligne).alert"
              class="warning py-1 px-3"
            >
              <v-icon>mdi-alert-circle-outline</v-icon>
              Un autre aliment doit être livré aux mêmes dates dans les mêmes lieux de stockage pour la même espèce.
            </div>
            <div
              v-if="validationDatesLigne(ligne)"
              class="error white--text py-1 px-3"
            >
              <v-icon color="white">
                mdi-alert-circle-outline
              </v-icon>
              Délai de livraison trop court
            </div>
            <div
              v-if="getLignesMelangePossible(ligne).length>1"
              class="d-flex align-center primary--text"
            >
              <div class="spacer" />
              <span>Mélanger au déchargement :</span>
              <v-checkbox
                :value="ligne.melangeDechargement"
                @click="toogleMelangeDechargement(ligne)"
              />
            </div>
          </template>
        </CardsListItemLigneCommande>
      </template>
    </CardsList>
    <div class="poids">
      <div class="lib-cumul no-wrap primary--text">
        Poids total
      </div>
      <div class="cumul no-wrap primary--text">
        {{ cumulQteCmde | formatDecimal(3) }} t
      </div>
    </div>

    <div>
      <div
        v-if="!zoneCommentaireVisible"
        v-show="lignesPanier && lignesPanier.length"
        class="btn-add"
        outlined
        color="grey"
      >
        <span @click="afficherZoneCommentaire()">
          + Ajouter un commentaire logistique
        </span>
        <span>
          <CardsHelp
            :page="'COMMENTAIRE_PANIER'"
            :niveau="'SOUS-TITRE'"
          />
        </span>
      </div>

      <div
        v-else
        class="commentaires"
      >
        <strong>Commentaires : </strong>
        <span>
          <CardsHelp
            :page="'COMMENTAIRE_PANIER'"
            :niveau="'SOUS-TITRE'"
          />
        </span>
        <div class="form-row">
          <div class="commentaire-predefini">
            <v-checkbox
              v-for="commentaire in paramsCommande.commentairesPredefinis"
              :key="commentaire.codeTypeSilo"
              v-model="form.commentairesEntete[commentaire.libelle]"
              :label="commentaire.libelle"
              color="primary"
              hide-details=""
            />
          </div>

          <v-textarea
            v-model="form.commentairesEntete['libre']"
            maxlength="80"
            background-color="#eee"
            label="Commentaire"
            placeholder="Les indications relatives aux dates de livraisons ne sont pas prises en compte"
          />
        </div>
      </div>
    </div>

    <div
      v-for="message in warningMessages"
      :key="message"
      class="display-inline-block warning--text"
    >
      {{ message }}
    </div>

    <div
      v-if="lignesPanier && lignesPanier.length"
      class="actions-panier"
    >
      <v-btn
        outlined
        @click="viderPanier()"
      >
        Vider le panier
      </v-btn>
      <v-btn
        outlined
        @click="continuerAchats()"
      >
        Continuer ma commande
      </v-btn>
      <v-btn @click="validerPanier()">
        Etape suivante
      </v-btn>
    </div>

    <v-dialog
      v-if="currentLigne"
      v-model="modal"
      transition="dialog-bottom-transition"
      :fullscreen="isMobile"
      persistent
      scrollable
    >
      <LineEdit
        :key="modalKey"
        :line="currentLigne"
        @cancel="modal=false"
        @validate="saveLigne"
      />
    </v-dialog>

    <v-dialog
      v-if="lieuxValidation.lines && lieuxValidation.lines.length"
      v-model="lieuxValidation.lines"
      width="900"
    >
      <LieuxDialog
        :lignes="lieuxValidation.lines"
        :is-error="lieuxValidation.isError"
        :is-vide="lieuxValidation.isVide"
        @submit="closeAlertPopup($event)"
      />
    </v-dialog>
    <v-dialog
      v-if="datesValidation.lignes && datesValidation.lignes.length"
      v-model="datesValidation.lignes"
      width="900"
    >
      <DatesDialog
        :lignes="datesValidation.lignes"
        @submit="closeDatesPopup()"
      />
    </v-dialog>
  </div>
</template>

<style lang="scss" scoped>
::v-deep .lieux_warning .infos-lieu-container {
  &,
  * {
    color: orange !important; //todo mettre le bon code couleur
  }
}

::v-deep .lieux_error .infos-lieu-container {
  &,
  * {
    color: #ff0000 !important; //todo mettre le bon code couleur
  }
}

.btn-add {
  // font-size: 0.9em;
  color: grey;
  cursor: pointer;
  padding: 0.3em 1em 0.3em 0;
}

.poids {
  margin-top: 10px;
  display: flex;
  flex-direction: row;

  .lib-cumul {
    flex: 2;
  }

  .cumul {
    flex: 1;
    text-align: right;
    font-size: 20px;
  }
}

.action-btn {
  padding: 0.4em;
  margin: -0.4em;
}

.desktop-ligne-actions {
  white-space: nowrap;
}

.actions-panier {
  margin-top: 2em;
  text-align: center;
  .v-btn {
    display: inline-block;
    margin: 0 1em;
  }
}

@import "~vuetify/src/styles/settings/_variables";

@media #{map-get($display-breakpoints, 'xs-only')} {
  .actions-panier {
    display: flex;
    flex-wrap: wrap-reverse;
    .v-btn {
      width: 100%;
      margin: 0;
      margin-top: 1em;
    }
  }
}

::v-deep .v-dialog {
  margin: 10px;
  border-radius: 10px;
}
</style>
